import { getCurrentYearFolder, getYearFolderFormat, safelyParseDate } from '@/utils/date';

const getTransactionEffectiveDate = (transaction) =>
	transaction?.EffectiveDate ??
	transaction?.PolicyEffectiveDate ??
	transaction?.FromDate ??
	transaction?.PolicyFromDate;

export const hasPositiveBalance = (transaction) => {
	const balance = Number(transaction?.Balance);
	return Number.isFinite(balance) && balance > 0;
};

export const isAssociatedToActiveDebtor = (transaction) => {
	const deals = Array.isArray(transaction?.deal)
		? transaction.deal
		: transaction?.deal
			? [transaction.deal]
			: [];
	return deals.some(
		(deal) =>
			deal?.pipeline === process.env.REACT_APP_PIPELINE_DEBTORS &&
			deal?.status !== 'Archived',
	);
};

export const getEligibleDebtorInvoices = (transactions = []) =>
	transactions.filter(
		(transaction) =>
			hasPositiveBalance(transaction) && !isAssociatedToActiveDebtor(transaction),
	);

export const buildDebtorDefaults = ({ transactions, clientName, fallbackOwnerDocId }) => {
	const eligible = getEligibleDebtorInvoices(transactions);
	if (eligible.length === 0) {
		return null;
	}

	const firstTransaction = eligible[0];
	const name = clientName || firstTransaction.ClientName || firstTransaction.clientName || '';
	const isMulti = eligible.length > 1;
	const dealName = isMulti
		? `Multi-invoice Debtor - ${name}`
		: `${firstTransaction.InvoiceNumber} - ${name}`;

	const sortedByEffectiveDate = eligible
		.map((transaction) => ({
			transaction,
			time: safelyParseDate(getTransactionEffectiveDate(transaction))?.getTime(),
		}))
		.filter(({ time }) => Number.isFinite(time))
		.sort((a, b) => a.time - b.time);

	const earliestDate = getTransactionEffectiveDate(
		sortedByEffectiveDate[0]?.transaction ?? eligible[0],
	);
	const yearFolder = getYearFolderFormat(earliestDate) || getCurrentYearFolder();
	const ownerDocId =
		firstTransaction.OwnerDocId ?? firstTransaction.ownerDocId ?? fallbackOwnerDocId;

	return {
		dealName,
		yearFolder,
		ownerDocId,
		transactions: eligible,
	};
};
